export default __webpack_public_path__ + "static/media/gasbiker_dark.e8e6ce25.png";